'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = require('redux');

var _coupon = require('../actions/coupon');

var DEFAULT_FILTER = {};
var filter = function filter() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FILTER;
    var action = arguments[1];

    switch (action.type) {
        case _coupon.FILTER_COUPONS:
            return Object.assign({}, state, action.filter);
        default:
            return state;
    }
};

var INITIAL_STATE = {
    isFetching: false,
    didInvalidate: false,
    items: [],
    pagination: {}
};
var coupons = function coupons() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _coupon.INVALIDATE_COUPONS:
            return _extends({}, state, {
                didInvalidate: true
            });
        case _coupon.REQUEST_COUPONS:
            return _extends({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case _coupon.RECEIVE_COUPONS:
            return _extends({}, state, {
                isFetching: false,
                didInvalidate: false,
                items: action.coupons,
                pagination: action.pagination
            });
        case _coupon.FAILURE_COUPONS:
            return _extends({}, state, {
                isFetching: false
            });
        default:
            return state;
    }
};

var couponReducer = (0, _redux.combineReducers)({
    coupons: coupons,
    filter: filter
});

exports.default = couponReducer;


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/coupon.js
// module id = 911
// module chunks = 0